import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=21f24d07&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
import style0 from "./Search.vue?vue&type=style&index=0&id=21f24d07&prod&lang=scss&scoped=true"
import style1 from "./Search.vue?vue&type=style&index=1&id=21f24d07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f24d07",
  null
  
)

export default component.exports